import { Input_Base } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Base.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';
import { Html, html } from 'rune-ts';
import klass from './Input.module.scss';
import { pipe, map, toArray } from '@fxts/core';
import { IToggle, Toggle } from '@shared/rune-component/Toggle/Toggle.ts';

interface InputToggles extends InputEditor {
  value: {
    id: number;
    label: string | Html;
    active?: boolean;
    disabled?: boolean;
    onClick?: (view: IToggle, event: MouseEvent) => void;
  }[];
}

export class Input_Toggles extends Input_Base<InputToggles> {
  protected inputTemplate() {
    return html`
      <div class="${klass.toggles}">
        ${pipe(
          this.data.value,
          map(
            ({ active, label, disabled, onClick }) => html`
              <div class="${klass.toggle}">
                ${new Toggle({ setting: active, disabled, onClick })} ${label}
              </div>
            `,
          ),
          toArray,
        )}
      </div>
    `;
  }

  getName(): ValidateField {
    return this.data.name;
  }

  getValue(): unknown {
    return this.data.value;
  }

  setError(): void {
    return void 0;
  }
}
